module.exports = __webpack_public_path__ + "static/media/vinayak.4f79b94b.png";